import styled from "@emotion/styled"

export const Container = styled.div<{
  isVisible: boolean
  offsetLeft: number
  offsetTop: number
}>`
  ${p => !p.isVisible && "display: none"};
  left: ${p => p.offsetLeft}px;
  position: absolute;
  top: ${p => p.offsetTop}px;
`
